import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly _sanitizer = inject(DomSanitizer);

  /**
   * Transforms a string value into a SafeHtml object.
   * This method bypasses Angular's built-in security for the given value.
   * WARNING: Only use this for trusted content, as it can expose your
   * application to XSS security vulnerabilities if the content is user-provided.
   * @param value The HTML or SVG string to sanitize. Can be null or undefined.
   * @returns A SafeHtml object that Angular can safely render via [innerHTML].
   */
  transform(value: string | null | undefined): SafeHtml {
    if (value === null || value === undefined) {
      return this._sanitizer.bypassSecurityTrustHtml('');
    }
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}
